import React from 'react';
import PropTypes from 'prop-types';
import {Utilities} from '@learningblocks/exp-constants';

const {COMPONENT_TYPE} = Utilities;
const OPTION_ID = 'optionID';
const CLONED_ITEM = 'cloned-item';

const TRANSPARENT = 0;
const OPAQUE = 1;
/**
 * Option: DesignSection component that holds a single option
 * in the Options Listing Component
 */
export function Option(props) {
  const [opacity, setOpacity] = React.useState(OPAQUE);

  const onAddCard = (event) => {
    event.preventDefault();
    props.setAsNextStep(props.optionId);
  };

  const dragStart = (event) => {
    removeAllGhostElements();
    setCustomGhostElement(event, props.type);
    event.dataTransfer.setData(OPTION_ID, props.optionId);
    setOpacity(TRANSPARENT);
  };

  const dragEnd = () => {
    setOpacity(OPAQUE);
    removeAllGhostElements();
  };

  let className = ` option option_${props.type.toLowerCase()} ${
    props.optionDisabled ? 'option_disabled' : ''
  }`;

  return (
    <div
      className={className}
      draggable={!props.optionDisabled}
      onDragStart={dragStart}
      onDragEnd={dragEnd}
      style={{opacity}}>
      {React.cloneElement(props.optionNode, {
        ...props.optionProps,
        addCard: onAddCard,
      })}
    </div>
  );
}

Option.propTypes = {
  /**
   * Unique Id for the option
   */
  optionId: PropTypes.number.isRequired,
  /**
   * String Value for type of option
   */
  type: PropTypes.string.isRequired,
  /**
   * Function to  involke when SetAsNextStep Button is invoked
   */
  setAsNextStep: PropTypes.func.isRequired,
  /**
   * Boolean specifying if option is disabled
   */
  optionDisabled: PropTypes.bool,
  /**
   * React component being listed
   */
  optionNode: PropTypes.element.isRequired,
  /**
   * Props associated with the particular option
   */
  optionProps: PropTypes.object.isRequired,
};

Option.defaultProps = {
  optionDisabled: false,
  type: '',
  optionProps: {},
};

/**
 * Function to setup a custom Ghost element for the item being dragged
 */
function setCustomGhostElement(event, elementType) {
  const firstChild = event.target.firstChild;
  const ghostElement = firstChild.cloneNode(true);
  ghostElement.id = CLONED_ITEM;
  ghostElement.style.position = 'absolute';
  ghostElement.style.top = '-5000px';
  if (elementType === COMPONENT_TYPE.FULL_WIDTH_CARD) {
    ghostElement.style.backgroundColor = '#fff';
    ghostElement.style.minWidth = '365px';
    ghostElement.style.maxWidth = '365px';
  }
  if (elementType === COMPONENT_TYPE.SLIDE_THREE_OPTION) {
    ghostElement.style.minWidth = '365px';
    ghostElement.style.maxWidth = '365px';
  }
  if (elementType === COMPONENT_TYPE.LINK_HEXAGON_MODAL) {
    ghostElement.style.background = 'rgba(0, 0, 0, 0.5) 0px';
  }
  document.body.appendChild(ghostElement);
  const {offsetX, offsetY} = event.nativeEvent;
  event.dataTransfer.setDragImage(ghostElement, offsetX, offsetY);
}

/**
 * Function to remove all existing GhostClone elements in document
 */
function removeAllGhostElements() {
  let ghostElements = document.querySelectorAll(`#${CLONED_ITEM}`);
  for (let element of ghostElements) {
    element.remove();
  }
}
